import { render, staticRenderFns } from "./ResetUserPassword.vue?vue&type=template&id=a4f0462c&scoped=true"
import script from "./ResetUserPassword.vue?vue&type=script&lang=js"
export * from "./ResetUserPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetUserPassword.vue?vue&type=style&index=0&id=a4f0462c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f0462c",
  null
  
)

export default component.exports